export const PARAMETERS = 'parameters';

//DIST026
export const DIST026_TREATMENT_KEY = 'dist-026';
export const DIST026_GROUP_PARAMETER_KEY = 'group';
export const DIST026_STATUS_PARAMETER_KEY = 'status';
export const DIST026_IS_ACTIVE_KEY = 'isActive';
export let DIST026_GROUP_PARAMETER_OPTIONS;

// SSM0001
(function (DIST026_GROUP_PARAMETER_OPTIONS) {
  DIST026_GROUP_PARAMETER_OPTIONS["control"] = "control";
  DIST026_GROUP_PARAMETER_OPTIONS["variant"] = "variant";
})(DIST026_GROUP_PARAMETER_OPTIONS || (DIST026_GROUP_PARAMETER_OPTIONS = {}));
export const SSM0001_TREATMENT_KEY = 'ssm-0001';
export const SSM0001_GROUP_PARAMETER_KEY = 'group';
export let SSM0001_GROUP_PARAMETER_OPTIONS;

// SSM0009
(function (SSM0001_GROUP_PARAMETER_OPTIONS) {
  SSM0001_GROUP_PARAMETER_OPTIONS["control"] = "control";
  SSM0001_GROUP_PARAMETER_OPTIONS["variant"] = "variant";
})(SSM0001_GROUP_PARAMETER_OPTIONS || (SSM0001_GROUP_PARAMETER_OPTIONS = {}));
export const SSM0009_TREATMENT_KEY = 'ssm-0009';
export const SSM0009_GROUP_PARAMETER_KEY = 'group';
export const SSM0009_GROUP_PARAMETER_OPTIONS = Object.freeze({
  control: 'control',
  variant: 'variant'
});

// SSM0010
export const SSM0010_TREATMENT_KEY = 'ssm-0010';
export const SSM0010_GROUP_PARAMETER_KEY = 'group';
export const SSM0010_GROUP_PARAMETER_OPTIONS = Object.freeze({
  control: 'control',
  variant: 'variant'
});

// HC0129
export const HC0129_TREATMENT_KEY = 'hc-0129';
export const HC0129_GROUP_PARAMETER_KEY = 'group';
export let HC0129_GROUP_PARAMETER_OPTIONS;

// SSBU-0004
(function (HC0129_GROUP_PARAMETER_OPTIONS) {
  HC0129_GROUP_PARAMETER_OPTIONS["control"] = "control";
  HC0129_GROUP_PARAMETER_OPTIONS["variant"] = "variant";
})(HC0129_GROUP_PARAMETER_OPTIONS || (HC0129_GROUP_PARAMETER_OPTIONS = {}));
export const SSBU_0004_TREATMENT_KEY = 'ssbu-0004';
export const SSBU_0004_GROUP_PARAMETER_KEY = 'group';
export let SSBU_0004_GROUP_PARAMETER_OPTIONS;

// SSBU-0008
(function (SSBU_0004_GROUP_PARAMETER_OPTIONS) {
  SSBU_0004_GROUP_PARAMETER_OPTIONS["control"] = "control";
  SSBU_0004_GROUP_PARAMETER_OPTIONS["variation"] = "variation";
})(SSBU_0004_GROUP_PARAMETER_OPTIONS || (SSBU_0004_GROUP_PARAMETER_OPTIONS = {}));
export const SSBU_0008_TREATMENT_KEY = 'ssbu-0008';
export const SSBU_0008_GROUP_PARAMETER_KEY = 'group';
export let SSBU_0008_GROUP_PARAMETER_OPTIONS;

// FTS-0011
(function (SSBU_0008_GROUP_PARAMETER_OPTIONS) {
  SSBU_0008_GROUP_PARAMETER_OPTIONS["control"] = "control";
  SSBU_0008_GROUP_PARAMETER_OPTIONS["variation"] = "variation";
})(SSBU_0008_GROUP_PARAMETER_OPTIONS || (SSBU_0008_GROUP_PARAMETER_OPTIONS = {}));
export const FTS_0011_TREATMENT_KEY = 'fts-0011';
export const FTS_0011_GROUP_PARAMETER_KEY = 'group';
export let FTS_0011_GROUP_PARAMETER_OPTIONS;

// SSBU-0009
(function (FTS_0011_GROUP_PARAMETER_OPTIONS) {
  FTS_0011_GROUP_PARAMETER_OPTIONS["control"] = "control";
  FTS_0011_GROUP_PARAMETER_OPTIONS["variant"] = "variant";
})(FTS_0011_GROUP_PARAMETER_OPTIONS || (FTS_0011_GROUP_PARAMETER_OPTIONS = {}));
export const SSBU_0009_TREATMENT_KEY = 'ssbu-0009';
export const SSBU_0009_GROUP_PARAMETER_KEY = 'group';
export let SSBU_0009_GROUP_PARAMETER_OPTIONS;

// FTS-0012
(function (SSBU_0009_GROUP_PARAMETER_OPTIONS) {
  SSBU_0009_GROUP_PARAMETER_OPTIONS["control"] = "control";
  SSBU_0009_GROUP_PARAMETER_OPTIONS["variation"] = "variation";
})(SSBU_0009_GROUP_PARAMETER_OPTIONS || (SSBU_0009_GROUP_PARAMETER_OPTIONS = {}));
export const FTS_0012_TREATMENT_KEY = 'fts-0012';
export const FTS_0012_GROUP_PARAMETER_KEY = 'group';
export let FTS_0012_GROUP_PARAMETER_OPTIONS;

// MC-0673
(function (FTS_0012_GROUP_PARAMETER_OPTIONS) {
  FTS_0012_GROUP_PARAMETER_OPTIONS["control"] = "control";
  FTS_0012_GROUP_PARAMETER_OPTIONS["variant"] = "variant";
})(FTS_0012_GROUP_PARAMETER_OPTIONS || (FTS_0012_GROUP_PARAMETER_OPTIONS = {}));
export const MC_0673_TREATMENT_KEY = 'mc-0673';
export const MC_0673_GROUP_PARAMETER_KEY = 'group';
export let MC_0673_GROUP_PARAMETER_OPTIONS;
(function (MC_0673_GROUP_PARAMETER_OPTIONS) {
  MC_0673_GROUP_PARAMETER_OPTIONS["control"] = "control";
  MC_0673_GROUP_PARAMETER_OPTIONS["variation"] = "variation";
})(MC_0673_GROUP_PARAMETER_OPTIONS || (MC_0673_GROUP_PARAMETER_OPTIONS = {}));